<div class="approved-study">
  <!-- Client name reads as a labelled field rather than a sentence floating in
       a centred row of its own. -->
  <div class="approved-study__client" *ngIf="this.isShowDisclosedClient">
    <span class="approved-study__client-label">Client name</span>

    <span class="approved-study__client-value" *ngIf="disclosedClient; else noClient">
      {{ disclosedClient }}
    </span>
    <ng-template #noClient>
      <span class="approved-study__client-value approved-study__client-value--none">Not declared</span>
    </ng-template>

    <button type="button"
            class="approved-study__client-edit"
            (click)="openDiscloseClientPopup()"
            title="Edit client name">
      <i class="far fa-edit"></i>
      <span>Edit</span>
    </button>
  </div>

  <!--
    One list, three sections. Previously each group was its own 60%-wide centred
    card with its own heading and its own repeated column headers, stacked — so
    DOCUMENTS fell off the bottom of the screen. Sections now share a single
    frame and a single set of column labels, which is what makes a vertical list
    fit without taking anything away.
  -->
  <div class="approved-study__list">
    <div class="approved-study__columns" aria-hidden="true">
      <span>File</span>
      <span>Submitted by</span>
      <span>Date</span>
      <span></span>
    </div>

    <!-- Documents first: the reports are what a vet reads before the images, and
         they were the section that used to fall off the bottom of the screen. -->
    <app-approved-table [headingText]="'Documents'"
                        [dataSource]="reportDatasource"
                        [openButtonText]="'OPEN'"
                        [showdocumentTypeName]="true"
                        [enforceDeclaration]="saleSettings?.pdfReports"
                        [saleSettings]="saleSettings"
                        (downloadButtonClicked)="openDocDownloader($event)"
                        [disclosedClient]="disclosedClient"
                        (openButtonClicked)="openPdf2($event)"></app-approved-table>

    <app-approved-table [headingText]="'X-Ray images'"
                        [dataSource]="xrayDatasource"
                        [openButtonText]="'OPEN'"
                        [enforceDeclaration]="saleSettings?.xRays"
                        [saleSettings]="saleSettings"
                        [isViewXraysAllowed]="isViewXraysAllowed"
                        [viewXrayValidationMessage]="viewXrayValidationMessage"
                        (downloadButtonClicked)="openXrayDownloaderPopup($event)"
                        [disclosedClient]="disclosedClient"
                        (openButtonClicked)="openViewer($event)"></app-approved-table>

    <app-approved-table [headingText]="'Videos'"
                        [dataSource]="scopeDatasource"
                        [openButtonText]="'OPEN'"
                        [showdocumentTypeName]="true"
                        [enforceDeclaration]="saleSettings?.scopeVideo"
                        [saleSettings]="saleSettings"
                        (downloadButtonClicked)="openVideoDownloader($event)"
                        [disclosedClient]="disclosedClient"
                        (openButtonClicked)="openVideoModal2($event)"></app-approved-table>
  </div>
</div>
